import React, { FC, memo, useState } from 'react'
import { IChoice, IConfirmNotificationWithChoicesProps } from './ConfirmNotificationWithChoices-types'
import { styles } from './ConfirmNotificationWithChoices-styles'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import Button from '../../blocks.simple/button/button'
import translate from '../../core/translate'

const ConfirmNotificationWithChoicesComponent: FC<IConfirmNotificationWithChoicesProps> = ({
    onSubmit,
    onReject,
    choices,
    text,
}) => {
    const [choicesData, setChoicesData] = useState<IChoice[]>(choices)

    const handleSubmit = () => {
        onSubmit(choicesData)
    }

    const handleChangeChoiceStatus = (value: string, isChecked: boolean) => {
        let updatedChoicesData = choicesData.map((choice) => {
            return choice.value === value ? { ...choice, isEnable: isChecked } : choice
        })

        setChoicesData(updatedChoicesData)
    }

    const renderChoices = () => {
        return choicesData.map(({ label, value, isEnable }) => {
            return (
                <div className={styles.checkboxWrapper}>
                    <Checkbox
                        key={value}
                        label={'      ' + label}
                        onClick={(isChecked: boolean) => handleChangeChoiceStatus(value, isChecked)}
                        checked={isEnable}
                        labelClassName={styles.checkboxLabel}
                        style={{ position: 'absolute', left: 0, top: 0 }}
                    />
                </div>
            )
        })
    }

    return (
        <div className={styles.ConfirmNotificationWithChoices}>
            <div className={styles.ConfirmNotificationWithChoices__button}>{text}</div>
            <div className={styles.ConfirmNotificationWithChoices__info}>{renderChoices()}</div>
            <div className={styles.ConfirmNotification__body}>
                <Button
                    indentSize="mini"
                    type="submit"
                    onClick={handleSubmit}
                    className={styles.ConfirmNotification__button_type_confirm}
                    mod="fill"
                >
                    {translate('yes')}
                </Button>
                <Button indentSize="mini" onClick={onReject}>
                    {translate('no')}
                </Button>
            </div>
        </div>
    )
}

export const ConfirmNotificationWithChoices = memo(ConfirmNotificationWithChoicesComponent)
